import { useT } from "@/i18n/LanguageContext";

const NUMS = ["01", "02", "03", "04"];

export default function Process() {
  const { t } = useT();
  const steps = t("process.steps");

  return (
    <section id="process" data-testid="process-section" className="relative py-28 md:py-40 overflow-hidden">
      <div className="blob blob-4" style={{ width: 400, height: 400, top: "10%", right: "-150px", opacity: 0.2 }} data-parallax="0.07" />

      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="reveal">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-[1px] w-10 bg-[#0F0524]/40" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-[#5C527A] font-semibold">
                {t("process.eyebrow")}
              </span>
            </div>
            <h2 className="font-display text-5xl md:text-7xl font-extralight leading-[0.95] tracking-[-0.04em] text-[#0F0524]">
              {t("process.titleA")} <span className="italic grad-text">{t("process.titleB")}</span>
            </h2>
          </div>
          <p className="reveal max-w-sm text-[15px] text-[#5C527A] leading-relaxed">
            {t("process.desc")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {steps.map((s, i) => (
            <article
              key={NUMS[i]}
              data-testid={`process-step-${NUMS[i]}`}
              className="reveal relative rounded-3xl bg-white border border-[#E5E3F0] p-7 md:p-8 hover:border-transparent hover:shadow-[0_20px_60px_-30px_rgba(164,155,255,0.5)] transition-all duration-500 group overflow-hidden"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="section-num text-[6rem] md:text-[7rem] leading-none absolute -top-2 -right-2 pointer-events-none">
                {NUMS[i]}
              </div>
              <div className="relative">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full iridescent text-[11px] font-bold text-[#0F0524]">
                  {NUMS[i]}
                </span>
                <h3 className="mt-6 font-display text-2xl font-medium text-[#0F0524] tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[13.5px] leading-relaxed text-[#5C527A]">{s.body}</p>
              </div>
              <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#00F0FF] via-[#A49BFF] to-[#FF00E5] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-700" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
